function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "least-permissions_svg__a",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeWidth: 8.067
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#DCE1EC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.034 64.033h60v-60h-60z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.08 3.231v16.883l7.954-1 7.953 1V3.231"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#least-permissions_svg__a)",
  d: "M31 30.838L44.109 44 71 17",
  transform: "translate(4 3)"
}));

function SvgLeastPermissions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 69
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3OCIgaGVpZ2h0PSI2OSI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMCUiIHkxPSI1NS4zMzklIiB5Mj0iNTUuMzM5JSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzAwOTA3RiIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzQ4RDU5RiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI4LjA2NyI+PGcgc3Ryb2tlPSIjRENFMUVDIj48cGF0aCBkPSJNNC4wMzQgNjQuMDMzaDYwdi02MGgtNjB6Ii8+PHBhdGggZD0iTTI2LjA4IDMuMjMxdjE2Ljg4M2w3Ljk1NC0xIDcuOTUzIDFWMy4yMzEiLz48L2c+PHBhdGggc3Ryb2tlPSJ1cmwoI2EpIiBkPSJNMzEgMzAuODM4TDQ0LjEwOSA0NCA3MSAxNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCAzKSIvPjwvZz48L3N2Zz4=";
export { SvgLeastPermissions as ReactComponent };